export default __webpack_public_path__ + "static/28-global-platinum-front-195b8b990ad388f92dcd156320281209.png";